/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { PartnerCategory } from 'types';
import { State } from 'redux/initialState';
import menuTypes from 'constants/menuTypes';

import { useTranslate } from 'hooks/useTranslate';
import { useGetActualSociety } from 'hooks/useGetActualSociety';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import transformData from 'modules/_shared/components/Tables/helpers';
import CustomDataTable from 'modules/_shared/components/Tables/CustomDataTable';
import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import { setModal } from 'modules/_shared/redux/modalActions';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { usePartnerCategoriesList } from 'modules/partners/hooks/usePartnerCategoriesList';
import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';

import { SocietyCorporateId } from 'types/Society';
import menuOptions from './menuOptions';
import tableColumns from './tableColumns';

function PartnerCategoriesList() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslate();
  const { societyId } = useParams();

  const columns = tableColumns(i18n);

  const { isAdmin, isReadOnly } = useGetPartnersSectionPermissions().data;
  const { data: tableData, isLoading } = usePartnerCategoriesList({
    societyId,
    isAdmin,
    isReadOnly,
  });

  const user = useSelector((state: State) => state?.user);
  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const partnerCategories = useSelector(
    (state: State) => state?.partnerCategories
  ) as PartnerCategory[];

  useGetMenu(menuTypes.EXTENDED);
  useGetActualSociety(societyId);

  const getPageDescription = () => (
    <p>
      {`${actualSociety?.name} ${t('HavePartnerCategories', {
        count: partnerCategories?.length,
      })}`}
    </p>
  );

  return (
    <Page id="partner-categories-list-page">
      <PageListHeader
        subTitle={t('PartnerCategories')}
        description={getPageDescription()}
        actions={
          isAdmin
            ? [
                <OperationMenuDots
                  title={t('AddPartnerCategory')}
                  menuOptions={menuOptions}
                  handleModal={(Modal: any) =>
                    dispatch(
                      setModal(
                        <Modal user={user} societyId={actualSociety?.['_id']} />
                      )
                    )
                  }
                  disabled={isReadOnly}
                />,
              ]
            : []
        }
      />

      {/* @ts-ignore */}
      <CustomDataTable
        data={transformData({
          data: tableData,
          columns,
        })}
        columns={columns}
        searchBy={t('Name')}
        pagination
        rowsPerPage={10}
        className="nk-tb-list"
        actions
        showDense
        showDownload={actualSociety?.corporateId !== SocietyCorporateId.AXA}
        fileName={`${t('PartnerCategories')} ${actualSociety?.name}`}
      />

      {isLoading && <CustomLoading />}
    </Page>
  );
}

export default PartnerCategoriesList;
